import { computed, ref } from 'vue'

const counter = ref(0)
const loadingBar = computed(() => counter.value > 0)

export function useLoadingBar () {
  return {
    loadingBar,
    async withLoadingBar (fn, willChain = false) {
      counter.value++
      try {
        return await fn()
      } finally {
        if (willChain) {
          // Delay cleanup to handle chained requests
          setTimeout(() => counter.value--, 100)
        } else {
          counter.value--
        }
      }
    },
  }
}
